// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../lib/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".session-list[data-v-640aea0d]{display:grid;grid-template-columns:repeat(auto-fill, minmax(290px, 1fr));grid-gap:16px;margin-top:15px;justify-items:center}.session-list .session-list-item[data-v-640aea0d]{align-self:start;width:100%}@media all and (-ms-high-contrast: none), (-ms-high-contrast: active){.session-list[data-v-640aea0d]{display:flex;flex-wrap:wrap}}\n", ""]);
// Exports
module.exports = exports;
